import { useEffect, useState } from "react";
import axios from "axios";
import { GALLERY_FALLBACK } from "@/data/gallery";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "ww_gallery_cache";

// Module-level cache so Hall ⇄ Grid switches never flash stale/placeholder
// paintings: the first paint uses the last known API result, then refreshes.
let cache = null;
try { cache = JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch {}

export default function useGalleryData() {
  const [gallery, setGallery] = useState(cache?.gallery || GALLERY_FALLBACK);
  const [paintings, setPaintings] = useState(cache?.paintings || []);
  const [loaded, setLoaded] = useState(!!cache);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [g, p] = await Promise.all([axios.get(`${API}/gallery`), axios.get(`${API}/paintings`)]);
        if (!active) return;
        cache = { gallery: g.data, paintings: p.data };
        try { sessionStorage.setItem(KEY, JSON.stringify(cache)); } catch {}
        setGallery(g.data);
        setPaintings(p.data);
      } catch (err) {
        // keep whatever we have — non-fatal
        console.warn("Gallery fetch failed; using cached/fallback content:", err);
      } finally {
        if (active) setLoaded(true);
      }
    })();
    return () => { active = false; };
  }, []);

  return { gallery, paintings, loaded };
}
